import * as Vue from 'vue';
// shadcn CSS vars — must load before tailwind.css so Tailwind utilities resolve the vars
import 'StylesSpa/tokens/colors.css';
import 'StylesSpa/theme.css';
import './tailwind.css';
import EnNotificationPanel from 'Components/notifications/EnNotificationPanel/EnNotificationPanel.vue';
import EnNavigationBar from 'Components/navigation/EnNavigationBar/EnNavigationBar.vue';
import vuetify from 'Plugins/vuetify';
import localForage from '@/localForage';
import i18n, { t as tFn } from '@/i18n';
import { createBaseRouter } from '@/routerHandler';
import { pinia } from 'Js/store/pinia';

export function createSharedApp(App, routes, area) {
    const app = Vue.createApp(App);

    app.use(i18n);
    app.use(vuetify);
    app.use(localForage);
    app.use(pinia);
    app.use(createBaseRouter(routes, area));

    app.component('en-notification-panel', EnNotificationPanel);
    app.component('en-navigation-bar', EnNavigationBar);
    app.config.globalProperties.t = (...args) => tFn(...args);

    const breadcrumb = Vue.ref([]);

    function updateBreadcrumbs(breadcrumbs) {
        breadcrumb.value = breadcrumbs;
    }

    app.provide('breadcrumb', {
        breadcrumbs: breadcrumb,
        updateBreadcrumbs,
    });

    return app;
}